module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ProjectGrid"
  }, _vm._l((_vm.projects), function(project, index) {
    return _c('div', {
      ref: "project",
      refInFor: true,
      staticClass: "ProjectGrid-project",
      attrs: {
        "id": project.hash
      }
    }, [(index > 0) ? _c('rule') : _vm._e(), _vm._v(" "), _c('break', {
      attrs: {
        "size": "2.5"
      }
    }), _vm._v(" "), (project.title) ? _c('h2', {
      staticClass: "t-heading-md c-white",
      domProps: {
        "innerHTML": _vm._s(project.title)
      }
    }) : _vm._e(), _vm._v(" "), (project.title && project.description) ? _c('break', {
      attrs: {
        "size": "0.25"
      }
    }) : _vm._e(), _vm._v(" "), (project.description) ? _c('markdown', {
      staticClass: "t-text-sm",
      attrs: {
        "content": project.description
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((project.sections), function(section, index) {
      return _c('div', {
        staticClass: "ProjectGrid-sections"
      }, [(index === 0) ? _c('break') : _vm._e(), _vm._v(" "), (section.title) ? _c('h2', {
        staticClass: "t-caps-lg c-white",
        domProps: {
          "innerHTML": _vm._s(section.title)
        }
      }) : _vm._e(), _vm._v(" "), (section.title) ? _c('break', {
        attrs: {
          "size": "0.5"
        }
      }) : _vm._e(), _vm._v(" "), (section.items) ? _c('flex-grid', {
        attrs: {
          "pad": ""
        }
      }, _vm._l((section.items), function(item, index) {
        return _c('flex-grid-cell', {
          key: index,
          attrs: {
            "size": section.cellSize
          }
        }, [(item.type === 'smugmug') ? _c('div', {
          staticClass: "ProjectGrid-thumbnail ProjectGrid-thumbnail--isSmugmug"
        }, [_c('div', {
          staticClass: "ProjectGrid-thumbnailImage"
        }, [_c('smugmug-album-thumbnail', {
          attrs: {
            "album-key": item['smugmug-album'],
            "image": item.image,
            "route": item.route,
            "show-lock-icon": _vm.showLockIcons
          }
        })], 1)]) : _vm._e(), _vm._v(" "), (item.type === 'vimeo') ? _c('div', {
          staticClass: "ProjectGrid-thumbnail ProjectGrid-thumbnail--isVimeo"
        }, [_c('div', {
          staticClass: "ProjectGrid-thumbnailImage"
        }, [_c('vimeo-thumbnail', _vm._b({}, 'vimeo-thumbnail', item, false))], 1)]) : _vm._e(), _vm._v(" "), (item.title) ? [_c('break', {
          attrs: {
            "size": "0.5"
          }
        }), _vm._v(" "), _c('h3', {
          staticClass: "ProjectGrid-thumbnailTitle c-white",
          class: {
            't-text-sm': section.cellSize === '1of4',
            't-heading-sm': section.cellSize === '2of4' || section.cellSize === '1of2'
          }
        }, [_vm._v("\n              " + _vm._s(item.title) + "\n            ")])] : _vm._e(), _vm._v(" "), _c('break')], 2)
      }), 1) : _vm._e()], 1)
    })], 2)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-196084e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectGrid.vue
// module id = 743
// module chunks = 1474